import '../Introduce/Introduce.css';

function Introduce() {
    return (
        <div className="introduce-container">
            {/* 메인 섹션: 배경 이미지가 깔리는 영역 */}
            <div className="intro-main-section">
                <div className="intro-overlay">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <div className="intro-content-card shadow-lg">
                                    <div className="intro-header mb-4">
                                        <p className="intro-sub-title">Law Firm Onpyeong</p>
                                        <h1 className="intro-main-title">
                                            온(溫) 마음을 다해서<br />
                                            평(平) 안을 드립니다
                                        </h1>
                                        <div className="intro-line"></div>
                                    </div>

                                    <div className="intro-body">
                                        <p className="philosophy-text">
                                            법률사무소 온평은 의뢰인의 고민을 단순히 법적으로만 해석하지 않습니다.
                                            의뢰인의 삶과 고통에 공감하며, 법률 솔루션을 통해 일상으로 복귀하실 수 있도록 돕습니다.
                                        </p>
                                        <p className="philosophy-text mt-3">
                                            차가운 법 현실 속에서 따뜻한 온기를 전하고,<br />
                                            법리 분석을 통해 흔들리지 않는 평안을 되찾아 드리는 것.<br />
                                            <strong>그것이 법률사무소 온평의 약속입니다.</strong>
                                        </p>
                                    </div>

                                    <div className="intro-commitments mt-5 row text-center">
                                        <div className="col-md-4 mb-3">
                                            <h5 className="fw-bold">진심</h5>
                                            <p className="small text-white">변호사가 직접 소통하며<br />진심을 다해 듣습니다.</p>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <h5 className="fw-bold">실력</h5>
                                            <p className="small text-white">치밀한 전략과 결과로<br />전문성을 증명합니다.</p>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <h5 className="fw-bold">책임</h5>
                                            <p className="small text-white">일상의 평안을 되찾을 때까지<br />끝까지 함께합니다.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Introduce;